import { render, staticRenderFns } from "./CustomBreadcrumb.vue?vue&type=template&id=4a61c8c3&scoped=true&"
import script from "./CustomBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./CustomBreadcrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a61c8c3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsItem } from 'vuetify/lib/components/VBreadcrumbs';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VBreadcrumbs,VBreadcrumbsItem,VDivider})
